import axios from "axios";
export const chatServiceApi = {
  getChatHistoryForStaff: async (staffId) => {
    const response = await axios.get(
      `https://tourvn.runasp.net/api/chat/history/${staffId}`
    );
    return response.data;
  },
  selectedChatRoom: async (userId, staffId) => {
    const response = await axios.post(
      "https://tourvn.runasp.net/api/chat/create",
      {
        customerId: userId,
        staffId: staffId,
      }
    );
    return response.data;
  },
  getMessage: async (chatRoomId) => {
    const response = await axios.get(
      `https://tourvn.runasp.net/api/chat/messages/${chatRoomId}`
    );
    return response.data;
  },
};
